function loadMPGSPayment (component, sessionId) {
  if (self === top) {
    var antiClickjack = document.getElementById("antiClickjack");
    if (antiClickjack) {
      antiClickjack.parentNode.removeChild(antiClickjack);
    }
  } else {
    top.location = self.location;
  }
  if (sessionId) {
    // eslint-disable-next-line no-undef
    PaymentSession.configure({
      session: sessionId,
      fields: {
        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
        card: {
          number: "#card-number",
          securityCode: "#security-code",
          expiryMonth: "#date_expiry_month",
          expiryYear: "#date_expiry_year"
        }
      },
      // SPECIFY YOUR MITIGATION OPTION HERE
      frameEmbeddingMitigation: ["javascript"],
      callbacks: {
        formSessionUpdate: function (response) {
          // HANDLE RESPONSE FOR UPDATE SESSION
          if (response.status) {
            if (response.status == "ok") {
              var order_id = window.location.pathname.split("/")[2];
              var response_details = {
                response_status: response.status,
                card_number: response.sourceOfFunds.provided.card.number,
                expiry_month: response.sourceOfFunds.provided.card.expiry.month,
                expiry_year: response.sourceOfFunds.provided.card.expiry.year
              };
    
              // check if the security code was provided by the user
              if (response.sourceOfFunds.provided.card.securityCode) {
                submitMPGSPayment(response.session.id, response_details);
              } else {
                removeErrorMessages();
                mpgsEnablePayButton();
                displayErrorMessage("Security code is missing.");
              }
            } else if (response.status == "fields_in_error") {
              removeErrorMessages();
              mpgsEnablePayButton();
              if (response.errors.cardNumber) {
                displayErrorMessage("Card number invalid or missing.");
              }
              if (response.errors.expiryYear) {
                displayErrorMessage("Expiry year invalid or missing.");
              }
              if (response.errors.expiryMonth) {
                displayErrorMessage("Expiry month invalid or missing.");
              }
              if (response.errors.securityCode) {
                displayErrorMessage("Security code invalid.");
              }
            } else if (response.status == "request_timeout") {
              removeErrorMessages();
              mpgsEnablePayButton();
              displayErrorMessage("Session update failed with request timeout: " + response.errors.message);
            } else if (response.status == "system_error") {
              removeErrorMessages();
              mpgsEnablePayButton();
              displayErrorMessage("Session update failed with system error: " + response.errors.message);
            }
          } else {
            removeErrorMessages();
            mpgsEnablePayButton();
            displayErrorMessage("Session update failed: " + response);
          }
        }
      }
    });
  }
  
  function submitMPGSPayment (token, data) {
    var paymentInfo = {
      expiry_month: data["expiry_month"],
      expiry_year: data["expiry_year"],
      card_number: data["card_number"],
      session_reference: token,
      response_status: data["response_status"]
    };
    component.submitMPGSPayment(paymentInfo);
  }
  
  function displayErrorMessage (errorMessage) {
    $(".payment-spinner").hide();
    $(".demo-icon.icon-lock").css("display", "inline-block");
    $("<div class=\"jqErrorMessage alert alert-danger ihjoz-alert ihjoz-alert-areeba\"><div>" +
      errorMessage +
      "</div></div>").insertBefore(".online-payment-form");
  }
  
  function mpgsEnablePayButton () {
    $("#mpgsPayButton").prop("disabled", false);
  }
};
  
var removeErrorMessages = function () {
  $(".jqErrorMessage").remove();
};
  
var mpgsDisablePayButton = function () {
  $(".payment-spinner").css("display", "inline-block");
  $(".demo-icon.icon-lock").hide();
  $("#mpgsPayButton").prop("disabled", true);
};
  
var updateMPGSPaymentSession = function () {
  PaymentSession.updateSessionFromForm("card");
};

export {
  loadMPGSPayment,
  mpgsDisablePayButton,
  updateMPGSPaymentSession
};
